import axios            from 'axios';
import authHeaderBearer from 'services/auth-header-bearer';
import drIds            from 'services/dr-ids';
import drIdsHashed      from 'services/dr-ids-hashed';

class EmployeeBenefitsService  {
  statistics(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/eb_statistic?' + parameters + drIds(), { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  walkIn(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/employees/find_by_nric?' + parameters + drIds(), { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  createWalkIn(parameters) {
    const docParam            = drIdsHashed();
    var dataParams            = parameters;
    dataParams.eb_doctor_id   = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/visits', dataParams, { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new EmployeeBenefitsService();